// extracted by mini-css-extract-plugin
export default {"dataPoint":"_1criT___DataPoint-module__dataPoint"};